import store from '@/store'

export default {
    // 权限判断
    auth: {
        beforeMount(el, binding) {
            let obj = binding.value
            if (store.state.operation[obj.name]) {
                if (obj.type) {
                    if (store.state.operation[obj.name][obj.type]) {
                        if ('disabled' in obj) {
                            if (obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        }
                        return
                    } else {
                        if ('disabled' in obj) {
                            if (!obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    }
                } else {
                    if (Object.keys(store.state.operation[obj.name]).length) { // 判断是否能跳转对应的列表
                        if ('disabled' in obj) {
                            if (obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    } else {
                        if ('disabled' in obj) {
                            if (!obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    }
                }
            } else {
                if ('disabled' in obj) {
                    if (!obj.disabled) {
                        el.style.display = 'none'
                        el.remove()
                    }
                } else {
                    el.style.display = 'none'
                    el.remove()
                }
                return
            }
        },
        updated(el, binding) {
            let obj = binding.value
            if (store.state.operation[obj.name]) {
                if (obj.type) {
                    if (store.state.operation[obj.name][obj.type]) {
                        if ('disabled' in obj) {
                            if (obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        }
                        return
                    } else {
                        if ('disabled' in obj) {
                            if (!obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    }
                } else {
                    if (Object.keys(store.state.operation[obj.name]).length) { // 判断是否能跳转对应的列表
                        if ('disabled' in obj) {
                            if (obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    } else {
                        if ('disabled' in obj) {
                            if (!obj.disabled) {
                                el.style.display = 'none'
                                el.remove()
                            }
                        } else {
                            el.style.display = 'none'
                            el.remove()
                        }
                        return
                    }
                }
            } else {
                if ('disabled' in obj) {
                    if (!obj.disabled) {
                        el.style.display = 'none'
                        el.remove()
                    }
                } else {
                    el.style.display = 'none'
                    el.remove()
                }
                return
            }
        }
    }
}